"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HelpRequestService = /** @class */ (function () {
    function HelpRequestService() {
    }
    HelpRequestService.prototype.setHelpRequestProvider = function (provider) {
        this.helpRequestProvider = provider;
    };
    HelpRequestService.prototype.getHelpRequestProvider = function () {
        return this.helpRequestProvider;
    };
    HelpRequestService.prototype.resetHelpRequestProvider = function () {
        this.helpRequestProvider = null;
    };
    HelpRequestService.prototype.startHelp = function () {
        if (this.helpRequestProvider && typeof this.helpRequestProvider.start === 'function') {
            this.helpRequestProvider.start();
        }
    };
    return HelpRequestService;
}());
exports.HelpRequestService = HelpRequestService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscFJlcXVlc3Quc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImhlbHBSZXF1ZXN0LnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTtJQUFBO0lBdUJBLENBQUM7SUFuQlUsbURBQXNCLEdBQTdCLFVBQThCLFFBQVE7UUFDbEMsSUFBSSxDQUFDLG1CQUFtQixHQUFHLFFBQVEsQ0FBQztJQUN4QyxDQUFDO0lBRU0sbURBQXNCLEdBQTdCO1FBQ0ksT0FBTyxJQUFJLENBQUMsbUJBQW1CLENBQUM7SUFDcEMsQ0FBQztJQUVNLHFEQUF3QixHQUEvQjtRQUNJLElBQUksQ0FBQyxtQkFBbUIsR0FBRyxJQUFJLENBQUM7SUFDcEMsQ0FBQztJQUdNLHNDQUFTLEdBQWhCO1FBQ0ksSUFBSSxJQUFJLENBQUMsbUJBQW1CLElBQUksT0FBTyxJQUFJLENBQUMsbUJBQW1CLENBQUMsS0FBSyxLQUFLLFVBQVUsRUFBRTtZQUNsRixJQUFJLENBQUMsbUJBQW1CLENBQUMsS0FBSyxFQUFFLENBQUM7U0FDcEM7SUFDTCxDQUFDO0lBRUwseUJBQUM7QUFBRCxDQUFDLEFBdkJELElBdUJDO0FBdkJZLGdEQUFrQiJ9